import { queryOptions, useQuery } from '@tanstack/react-query';

import API from '@api';
import { withSsrCache } from '../../ssrCache';

/** Блог шеф-повара (/cook): контент редакционный, меняется редко */
const CHEF_BLOG_STALE_TIME = 5 * 60 * 1000;
const CHEF_BLOG_GC_TIME = 10 * 60 * 1000;

export const chefInfoQueryOptions = () =>
  queryOptions({
    queryKey: ['chefInfo'],
    queryFn: () => API.getChefInfo({}),
    select: res => res.getBlogItems?.[0] ?? null,
    staleTime: CHEF_BLOG_STALE_TIME,
    gcTime: CHEF_BLOG_GC_TIME
  });

export const useChefInfoQuery = () => useQuery(chefInfoQueryOptions());

export const recipesVideoCodesQueryOptions = () =>
  withSsrCache(
    queryOptions({
      queryKey: ['recipesVideoCodes'],
      queryFn: () => API.getRecipesVideoCodes(),
      select: res => res.getRecipesVideoCodes ?? [],
      staleTime: CHEF_BLOG_STALE_TIME,
      gcTime: CHEF_BLOG_GC_TIME
    })
  );

export const useRecipesVideoCodesQuery = () =>
  useQuery(recipesVideoCodesQueryOptions());

/** Не путать с getRecipesPopular из recipes.ts — другой документ и фрагменты */
export const chefBlogPopularRecipesQueryOptions = (
  params: Parameters<typeof API.getPopularRecipes>[0]
) =>
  queryOptions({
    queryKey: ['chefBlogPopularRecipes', params],
    queryFn: () => API.getPopularRecipes(params),
    select: res => res.getRecipesPopular ?? [],
    staleTime: CHEF_BLOG_STALE_TIME,
    gcTime: CHEF_BLOG_GC_TIME
  });

export const useChefBlogPopularRecipesQuery = (
  params: Parameters<typeof API.getPopularRecipes>[0]
) => useQuery(chefBlogPopularRecipesQueryOptions(params));

export const popularArticlesQueryOptions = (
  params: Parameters<typeof API.getPopularArticles>[0]
) =>
  withSsrCache(
    queryOptions({
      queryKey: ['popularArticles', params],
      queryFn: () => API.getPopularArticles(params),
      select: res => res.getPopularArticles?.articlesItems ?? [],
      staleTime: CHEF_BLOG_STALE_TIME,
      gcTime: CHEF_BLOG_GC_TIME
    })
  );

/**
 * Блок «Полезные статьи» на /cook. Параметры были инлайновым литералом в
 * компоненте, а они целиком входят в ключ (['popularArticles', params]) —
 * SSR-префетчу пришлось бы повторять их руками, и любая правка молча ломала
 * бы попадание в кэш. Общая фабрика, как у «Это интересно» на /faq.
 */
export const chefBlogArticlesQueryOptions = () =>
  popularArticlesQueryOptions({
    setLimit: 8,
    page: 1,
    imageSizeFilter: 'w570'
  });

export const usePopularArticlesQuery = (
  params: Parameters<typeof API.getPopularArticles>[0]
) => useQuery(popularArticlesQueryOptions(params));
